export enum ETimeSelectorType {
  DROPDOWN = "dropdown",
  DRAWER = "drawer",
}

export enum EMoneySelectorType {
  DROPDOWN = "DROPDOWN",
  DRAWER = "DRAWER",
}
